var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"feedback-card card border-0 rounded-lg h-100"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-4 pr-2"},[_c('b-aspect',{attrs:{"aspect":"1:1"}},[_vm._t("avatar")],2)],1),_c('div',{staticClass:"position-relative col-8 pl-2"},[_vm._t("default")],2)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }